import React, { useState } from 'react';
import { COLORS } from '../../../styles/UISystem';
import { ChatInputNormal } from './ChatInputNormal';

/**
 * ChatInputNormalExample Component
 * 
 * Used for displaying ChatInputNormal examples in the UI System
 */
export const ChatInputNormalExample = () => {
  const [emptyValue, setEmptyValue] = useState('');
  const [placeholderValue, setPlaceholderValue] = useState('');
  const [filledValue, setFilledValue] = useState('Hello there!');
  
  const handleSend = (message) => {
    console.log('Message sent:', message);
    // Clear the input after sending
    if (message === emptyValue) setEmptyValue('');
    if (message === placeholderValue) setPlaceholderValue('');
    if (message === filledValue) setFilledValue('');
  };
  
  return (
    <div style={{ marginBottom: '60px' }}>
      <div style={{ 
        fontSize: '24px', 
        fontWeight: 'bold', 
        color: COLORS.DARK_GRAY, 
        marginBottom: '32px',
        textAlign: 'center'
      }}>
        ChatInputNormal
      </div>
      
      {/* Empty example */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ 
          marginBottom: '8px', 
          fontSize: '16px', 
          color: COLORS.DARK_GRAY,
          textAlign: 'center'
        }}>
          empty
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ChatInputNormal 
            value={emptyValue}
            onChange={setEmptyValue}
            onSend={handleSend}
          />
        </div>
      </div>
      
      {/* Placeholder example */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ 
          marginBottom: '8px', 
          fontSize: '16px', 
          color: COLORS.DARK_GRAY,
          textAlign: 'center'
        }}>
          placeholder
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ChatInputNormal 
            placeholder="Type a message..."
            value={placeholderValue}
            onChange={setPlaceholderValue}
            onSend={handleSend}
          />
        </div>
      </div>
      
      {/* Filled example */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ 
          marginBottom: '8px', 
          fontSize: '16px', 
          color: COLORS.DARK_GRAY,
          textAlign: 'center'
        }}>
          filled
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ChatInputNormal 
            value={filledValue}
            onChange={setFilledValue}
            onSend={handleSend}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatInputNormalExample;
